import { render, staticRenderFns } from "./buttons_steps.vue?vue&type=template&id=2ed8d3ed"
import script from "./buttons_steps.vue?vue&type=script&lang=js"
export * from "./buttons_steps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports